import { Component } from 'react';
import 'react-phone-number-input/style.css'
import { connect } from 'react-redux';
import { ReduxState } from '../../store/state';
import {
  Text,
  Card,
  CardBody,
  Button,
  Flex,
  Divider,
  Box,
} from '@chakra-ui/react';
import { MdShoppingCart } from 'react-icons/md';
import { asyncLogout } from '../../store/auth/initiators';
import { asyncUpdateUser } from '../../store/user/initiators';
import { asyncCalculateFees } from '../../store/page/initiators/asyncCalculateFees';
import { updatePageOrderInputs, updateSelectedOrderItem } from '../../store/page/actions';
import UserLocationForm from '../location/UserLocationForm';
import AppButton from '../global/forms/AppButton';
import { CartItem } from '../../store/cart/types';
import { colors } from '../../assets/colors';

interface CartCheckoutFormProps {
  groupedCartItems?: Record<string, CartItem[]> 
  isCalculating: boolean;
  goBack: () => void;
  goForward: () => void;
}

class CartCheckoutForm extends Component<CartCheckoutFormProps> {
  render() {
      const { groupedCartItems } = this.props; 
      const calculating = this.props.isCalculating;
      return (
        <Card borderRadius={20}>
          <CardBody padding={8}>
          <UserLocationForm />
          <Divider m={2} />
          {groupedCartItems &&
        Object.entries(groupedCartItems).map(([businessLocationId, items]) => {
          const selectedItems = items.filter(item => item.selected)
          return (
          <Box key={businessLocationId} mb={6}>
            {selectedItems.length ? (
            <Text fontSize="xs" color="gray.600" mb={2}>
              Shipping from the same location (grouped into one order)
            </Text>
            ) : null}
            {items.map((item) => {
              if (!item.selected) return null;
              return (
              <Flex flexDirection={'row'} align={'center'} mb={1} key={item._id}> 
                <MdShoppingCart />
                <Text ml={2}><Button borderRadius={'full'} size={'sm'}>{item.quantity}</Button> {item.reference?.pageData?.title ? item.reference.pageData.title : ''}</Text>
              </Flex>
              )
            })}
          </Box>
        )})}
          <Divider m={2} />
          <Box maxW={'xl'}>
          <AppButton text={'Back'} onClick={() => this.props.goBack()} color={colors.shade1}/>
            <AppButton 
              text={ calculating ? 'Calculating...' : 'Next'}
              color={ calculating ? '#F7941D' : undefined }
              isDisabled={calculating}
              onClick={() =>{ 
                this.props.goForward()
              }}
            />
          </Box>
          </CardBody>
        </Card>
      );
    }
}

const mapStateToProps = (state: ReduxState) => {
  const { isCalculating } = state.cart;
  return { isCalculating };
};

export default connect(mapStateToProps, {
  asyncLogout,
  asyncUpdateUser,
  updatePageOrderInputs,
  updateSelectedOrderItem,
  asyncCalculateFees
})(CartCheckoutForm);
